<template>
  <div class="Model">
    <Modal
      v-model="modelStatus"
      :title="title"
      :closable="false"
      :mask-closable="false"
      :footer-hide="true"
    >
      
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="110">
        <FormItem label="执行器" prop="jobGroup">
          <Select v-model="formValidate.jobGroup" placeholder="请选择执行器">
            <Option v-for="item in JobGroupList" :value="item.id" :key="item.id">{{ item.title }}</Option>
          </Select>
        </FormItem>
        <FormItem label="路由策略" prop="executorRouteStrategy">
          <Select v-model="formValidate.executorRouteStrategy" placeholder="请选择路由策略">
            <Option v-for="item in ExecutorRouteStrategyEnum" :value="item" :key="item">{{ item }}</Option>
          </Select>
        </FormItem>
        <FormItem label="运行模式" prop="glueType">
          <Select v-model="formValidate.glueType" placeholder="请选择运行模式">
            <Option v-for="item in GlueTypeEnum" :value="item" :key="item">{{ item }}</Option>
          </Select>
        </FormItem>
        <FormItem label="阻塞处理策略" prop="executorBlockStrategy">
          <Select v-model="formValidate.executorBlockStrategy" placeholder="请选择阻塞处理策略">
            <Option v-for="item in ExecutorBlockStrategyEnum" :value="item" :key="item">{{ item }}</Option>
          </Select>
        </FormItem>
        <FormItem label="任务超时时间" prop="executorTimeout">
            <Input v-model="formValidate.executorTimeout" placeholder="请输入任务超时时间"></Input>
        </FormItem>
        <FormItem label="负责人" prop="author">
            <Input v-model="formValidate.author" placeholder="请输入负责人"></Input>
        </FormItem>
        <FormItem label="任务描述" prop="jobDesc">
            <Input v-model="formValidate.jobDesc" placeholder="请输入任务描述"></Input>
        </FormItem>
        <FormItem label="Cron" prop="jobCron">
            <Input v-model="formValidate.jobCron" placeholder="请输入Cron"></Input>
        </FormItem>
        <FormItem label="JobHandler" prop="executorHandler">
            <Input v-model="formValidate.executorHandler" placeholder="请输入JobHandler"></Input>
        </FormItem>
        <FormItem label="子任务ID" prop="childJobId">
            <Input v-model="formValidate.childJobId" placeholder="请输入子任务ID"></Input>
        </FormItem>
        <FormItem label="失败重试次数" prop="executorFailRetryCount">
            <Input v-model="formValidate.executorFailRetryCount" placeholder="请输入失败重试次数"></Input>
        </FormItem>
        <FormItem label="报警邮件" prop="alarmEmail">
            <Input v-model="formValidate.alarmEmail" placeholder="请输入报警邮件"></Input>
        </FormItem>
        <FormItem label="Desc" prop="executorParam">
            <Input v-model="formValidate.executorParam" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入任务参数"></Input>
        </FormItem>
    </Form>
    <!-- 按钮组 -->
    <div class="btn-box">
      <Button  class="ys-cancel" @click="cancel('formValidate')" style="width: 100px; margin-right: 20px">取消</Button>
      <Button class="ys-confirm" type="primary" @click="ok('formValidate')" style="width: 100px;">确认</Button>
    </div>
    </Modal>
  </div>
</template>
<script>
import { 
  mapActions
} from "vuex";
export default {
  props:{
    modelStatus: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '新增'
    },
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formValidate: {
        jobGroup: '',
        executorRouteStrategy: '',
        glueType: '',
        executorBlockStrategy: '',
        executorTimeout: '',
        author: '',
        jobDesc: '',
        jobCron: '',
        executorHandler: '',
        childJobId: '',
        executorFailRetryCount: '',
        alarmEmail: '',
        executorParam: ''
      },
      ruleValidate: {
        jobGroup: [
          { required: true, message: '请选择执行器', trigger: 'change', type: 'number' }
        ],
        executorRouteStrategy: [
          { required: true, message: '请选择路由策略', trigger: 'change' }
        ],
        glueType: [
            { required: true, message: '请选择运行模式', trigger: 'change' }
        ],
        executorBlockStrategy: [
           { required: true, message: '请选择阻塞处理策略', trigger: 'change' }
        ],
        executorTimeout: [
            { required: true, message: '请输入任务超时时间', trigger: 'blur' }
        ],
        author: [
            { required: true, message: '请输入负责人', trigger: 'blur' }
        ],
        jobDesc: [
            { required: true, message: '请输入任务描述', trigger: 'blur' }
        ],
        jobCron: [
            { required: true, message: '请输入Cron', trigger: 'blur' }
        ],
        executorHandler: [
            { required: true, message: '请输入JobHandler', trigger: 'blur' }
        ],
        childJobId: [
            { required: true, message: '请输入子任务ID', trigger: 'blur' }
        ],
        executorFailRetryCount: [
            { required: true, message: '请输入失败重试次数', trigger: 'blur' }
        ],
        alarmEmail: [
            { required: true, message: '请输入报警邮件', trigger: 'blur' }
        ],
        executorParam: [
            { required: true, message: '请输入任务参数', trigger: 'blur' }
        ],
      },
      JobGroupList: [],
      ExecutorRouteStrategyEnum: [],
      GlueTypeEnum: [],
      ExecutorBlockStrategyEnum: [],
    }
  },
  methods:{
    ...mapActions([
      'sa_SpringJobInfoView_index', // 下拉列表
      'sa_SpringJobInfoView_add', // 新增
      'sa_SpringJobInfoView_updateById', // 编辑回显
      'sa_SpringJobInfoView_update', // 编辑保存
    ]),
    ok (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          // this.$Message.success('Success!');
          this.id ? this.sa_SpringJobInfoView_updates() : this.sa_SpringJobInfoView_adds();
          // this.$emit('handle-model', {code: 1})
        } else {
          this.$Message.error('Fail!');
        }
      })
    },
    cancel (name) {
      this.$refs[name].resetFields();
      this.$emit('handle-model', {code: 2})
    },
    // 获取下拉列表
    async sa_SpringJobInfoView_indexs() {
      try {
        const data = await this.sa_SpringJobInfoView_index();
        console.log(data, '----888')
        this.JobGroupList = data.JobGroupList;
        this.ExecutorRouteStrategyEnum = data.ExecutorRouteStrategyEnum;
        this.GlueTypeEnum = data.GlueTypeEnum;
        this.ExecutorBlockStrategyEnum = data.ExecutorBlockStrategyEnum;
        // this.selectList = data.map.JobGroupList;
      } catch (error) {
        console.log(error);
      }
    },
    // 新增
    async sa_SpringJobInfoView_adds() {
      try {
        const data = await this.sa_SpringJobInfoView_add(this.formValidate);
        console.log(data, '---')
        this.$Message.success('新增成功~~');
        this.$emit('handle-model', {code: 1})
      } catch (error) {
        console.log(error);
      }
    },
    // 编辑回显
    async sa_SpringJobInfoView_updateByIds() {
      try {
        const data = await this.sa_SpringJobInfoView_updateById({id:this.id});
        console.log(data, '编辑回显');
        this.formValidate = data;
      } catch (error) {
        console.log(error);
      }
    },
    // 编辑保存
    async sa_SpringJobInfoView_updates() {
      try {
        let ev = {
          ...this.formValidate,
          id: this.id
        }
        const data = await this.sa_SpringJobInfoView_update(ev);
        this.$Message.success('编辑成功~~');
        this.$emit('handle-model', {code: 1})
      } catch (error) {
        console.log(error);
      }
    }
  },
  mounted() {
    console.log('88888888888888888', this.id)
    this.sa_SpringJobInfoView_indexs();
    // 编辑回显
    this.id ? this.sa_SpringJobInfoView_updateByIds() : '';
  }
}
</script>
<style lang="less" scoped>
.btn-box {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
  margin-top: 40px;
}
</style>